import { atom, useAtom } from 'jotai';
export const contextAtom = atom();
export const useContextAtom = () => {
    return useAtom(contextAtom);
};
